import { render } from "./SearchOperationsLogs.vue?vue&type=template&id=06ec0f16&scoped=true"
import script from "./SearchOperationsLogs.vue?vue&type=script&lang=js"
export * from "./SearchOperationsLogs.vue?vue&type=script&lang=js"

import "./SearchOperationsLogs.vue?vue&type=style&index=0&id=06ec0f16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ec0f16"]])

export default __exports__